import React, { useState } from 'react';
import Section from '../ui/Section.jsx';
import DocItem from '../ui/DocItem.jsx';
import RepoItem from '../ui/RepoItem.jsx';
import AddLinkModal from '../modals/AddLinkModal.jsx';
import { DocGlyph, RepoGlyph } from '../ui/LinkGlyphs.jsx';

function EmptyRow({ glyph, label }) {
  return (
    <div className="flex items-center" style={{ gap: 7, color: '#9A9A95' }}>
      <span style={{ color: '#C7C5BC', display: 'inline-flex', flexShrink: 0 }}>{glyph}</span>
      <span className="text-[12px]" style={{ color: '#9A9A95' }}>{label}</span>
    </div>
  );
}

export default function DocsAndRepo({ project }) {
  const [open, setOpen]   = useState(false);
  const [docs, setDocs]   = useState(project.docs || []);
  const [repos, setRepos] = useState(project.repositories || []);

  function handleSaved({ docs: newDocs = [], repositories: newRepos = [] }) {
    // Prepend each kind to its own pane (one submit can create both).
    if (newDocs.length)  setDocs(prev => [...newDocs, ...prev]);
    if (newRepos.length) setRepos(prev => [...newRepos, ...prev]);
  }

  function handleDocDeleted(id) {
    setDocs(prev => prev.filter(d => d.id !== id));
  }

  function handleRepoDeleted(id) {
    setRepos(prev => prev.filter(r => r.id !== id));
  }

  const headerRight = (
    <button
      onClick={() => setOpen(true)}
      className="text-[12px] px-2.5 py-1 rounded-md border hover:bg-[#FBFBF8]"
      style={{ borderColor: '#E0DFD9', background: '#fff', color: '#1A1A1A', cursor: 'pointer' }}
    >+ Add</button>
  );

  return (
    <>
      <Section id="docs" title="Docs & repo" count={`${docs.length} docs`} headerRight={headerRight}>
        <div className="grid gap-6" style={{ gridTemplateColumns: '1.4fr 1fr' }}>
          <div className="rounded-lg border p-3" style={{ background: '#fff', borderColor: '#ECEBE5' }}>
            <h4 className="text-[12px] uppercase tracking-wider mb-2" style={{ color: '#9A9A95', letterSpacing: '0.08em' }}>
              Documentation
            </h4>
            {docs.length === 0 ? (
              <EmptyRow glyph={<DocGlyph />} label="No documentation yet" />
            ) : (
              <div className="space-y-2">
                {docs.map((d) => <DocItem key={d.id} doc={d} onDeleted={handleDocDeleted} />)}
              </div>
            )}
          </div>
          <div className="rounded-lg border p-3" style={{ background: '#fff', borderColor: '#ECEBE5' }}>
            <h4 className="text-[12px] uppercase tracking-wider mb-2" style={{ color: '#9A9A95', letterSpacing: '0.08em' }}>
              Repository
            </h4>
            {repos.length === 0 ? (
              <EmptyRow glyph={<RepoGlyph />} label="No repositories yet" />
            ) : (
              repos.map((r, i) => <RepoItem key={r.id} repo={r} dividerTop={i > 0} onDeleted={handleRepoDeleted} />)
            )}
          </div>
        </div>
      </Section>
      <AddLinkModal
        open={open}
        onClose={() => setOpen(false)}
        projectId={project.id}
        onSaved={handleSaved}
      />
    </>
  );
}
